import { useContext, useEffect, useRef, useState } from "react"
import { store } from "components/Common/Socket/store"
import { runAdminCommand } from "./runAdminCommand"

export default function useAdminCommand() {
  const context = useContext(store)
  const { socket, socketClientId } = context?.state?.socket || {}
  const active = useRef()
  const alive = useRef(true)
  const [state, setState] = useState({ status: "idle" })
  useEffect(() => () => { alive.current = false; active.current?.operation.cancel() }, [])
  const run = async (submit, onSuccess, verifyOnly = false) => {
    if (active.current?.pending) return
    const operation = runAdminCommand({
      submit: id => submit(id, socketClientId), socket, verifyOnly,
      ...(verifyOnly && { correlationId: active.current?.operation.correlationId }),
    })
    active.current = { operation, submit, onSuccess, pending: true }
    setState({ status: "pending" })
    const result = await operation.promise
    if (!alive.current) return
    active.current.pending = false
    setState(result)
    if (result.status === "saved") onSuccess?.(result)
  }
  return {
    ...state,
    start: (submit, onSuccess) => run(submit, onSuccess),
    check: () => run(active.current.submit, active.current.onSuccess, true),
  }
}
